export default function getWhatsappUrl(numbers) {
  return `https://wa.me/${numbers}`
}
